define([
    "./nlgOperationOverviewModule",
    "./nlgOperationOverviewService",
    "./nlgOperationOverview",
    "./nlgOperationOverviewInfo/nlgOperationOverviewInfo"
], function () {
});
